import { FC } from 'react';

import { SavedSearchDetails } from '@bvi/dashboard/widgets/saved-search-details';

export const SavedSearchDetailsPage: FC = () => {
  return <SavedSearchDetails />;
};
